import { FC } from 'react';

import { useTranslation } from '@mint-lib/i18n';

import { Button, IconButton } from '@myn/mui';

import { useCurrentVersionId } from '../../../hooks/useGetBuyingPlanData.js';

type ExportButtonProps = {
  disabled: boolean;
  isDesktopWidth: boolean;
  handleExportRequest: (versionId: number) => Promise<void>;
};

const ExportButton: FC<ExportButtonProps> = ({
  disabled,
  isDesktopWidth,
  handleExportRequest,
}) => {
  const { t } = useTranslation('@myn/planning');

  const currentVersionId = useCurrentVersionId();

  const handleExportMediaPlan = async () => {
    if (currentVersionId) {
      handleExportRequest(currentVersionId);
    }
  };

  return isDesktopWidth ? (
    <Button
      color="primary"
      variant="outlined"
      size="medium"
      startIcon={'Export'}
      onClick={handleExportMediaPlan}
      disabled={disabled}
    >
      {t('Export')}
    </Button>
  ) : (
    <IconButton
      color="primary"
      variant="outlined"
      size="medium"
      icon="Export"
      onClick={handleExportMediaPlan}
      disabled={disabled}
    />
  );
};

export default ExportButton;
